import {Component, OnChanges, SimpleChanges} from '@angular/core';
import {CapitalCasePipe} from "../../../../pipes/capital-case.pipe";
import {DxButtonComponent, DxDataGridComponent, DxFormComponent, DxTemplateDirective} from "devextreme-angular";
import {
    DxiButtonComponent,
    DxiColumnComponent,
    DxiItemComponent,
    DxoColumnChooserComponent,
    DxoExportComponent, DxoFilterRowComponent, DxoHeaderFilterComponent, DxoLoadPanelComponent, DxoPagerComponent, DxoPagingComponent,
    DxoScrollingComponent, DxoSortingComponent, DxoToolbarComponent
} from "devextreme-angular/ui/nested";
import {UserAvatarEmailComponent} from "../../../../components/utils/user-avatar-email/user-avatar-email.component";
import {TimeOffRequestsComponent} from "../time-off-requests.component";
import {LieuDayGridViewDto, LieuDaySlotType} from "@services";
import {NgClass} from "@angular/common";
import EnumUtils from "../../../../shared/enum-utils";
import {LieuDayPopupComponent} from "./lieu-day-popup/lieu-day-popup.component";
import {TimeOffFilterPanelComponent} from "../time-off-filter-panel/time-off-filter-panel.component";

@Component({
  selector: 'app-lieu-days',
    imports: [
        CapitalCasePipe,
        DxButtonComponent,
        DxDataGridComponent,
        DxTemplateDirective,
        DxiButtonComponent,
        DxiColumnComponent,
        DxiItemComponent,
        DxoColumnChooserComponent,
        DxoExportComponent,
        DxoFilterRowComponent,
        DxoHeaderFilterComponent,
        DxoLoadPanelComponent,
        DxoPagerComponent,
        DxoPagingComponent,
        DxoScrollingComponent,
        DxoSortingComponent,
        DxoToolbarComponent,
        UserAvatarEmailComponent,
        NgClass,
        LieuDayPopupComponent,
        TimeOffFilterPanelComponent,
    ],
  templateUrl: './lieu-days.component.html'
})
export class LieuDaysComponent extends TimeOffRequestsComponent<LieuDayGridViewDto> implements OnChanges {
    constructor() {
        super();
        this.init(LieuDayGridViewDto);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['employeeId']) {
            this.dataSource = this.dataSources.lieuDays(this.employeeId);
        }
    }

    typeOptions = EnumUtils.getEnumOptions(LieuDaySlotType);
    dataSource = this.dataSources.lieuDays(null);
    filterModel: LieuDayGridViewDto = new LieuDayGridViewDto();
    gridFieldName = (name: keyof LieuDayGridViewDto): string => name;
    filterModelName = (name: keyof LieuDayGridViewDto): string => name;
    protected override exportName: string = "Lieu Days";
    protected tabName = 'lieu-day';

    getCellData(cellInfo: { data: LieuDayGridViewDto }) {
        return cellInfo.data;
    }
}
